import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "../lib/api";
import { BookCover, MadeWith } from "../components/Bits";
import { PageLoading } from "../context/AuthContext";
import JoinReaders from "../components/JoinReaders";
import { NotFound } from "./PublicBook";

export default function PublicAuthor() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    http.get(`/public/authors/${slug}`).then(({ data }) => setData(data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <NotFound what="author" />;
  if (!data) return <PageLoading />;
  const { author, books } = data;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-14" data-testid="public-author-page">
      <section className="grid lg:grid-cols-12 gap-10 items-start border-b border-[#E5DEC9] pb-14">
        <div className="lg:col-span-2">
          {author.picture ? (
            <img src={author.picture} alt={author.name} className="w-28 h-28 object-cover grayscale border border-[#121210]" />
          ) : (
            <div className="w-28 h-28 bg-[#121210] text-[#FDFBF7] flex items-center justify-center font-display text-5xl italic">{author.name?.[0]}</div>
          )}
        </div>
        <div className="lg:col-span-6">
          <p className="label-mono">Author</p>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tight mt-2" data-testid="author-name">{author.name}</h1>
          {author.bio && <p className="mt-6 text-lg leading-relaxed text-[#5C584E] whitespace-pre-line" data-testid="author-bio">{author.bio}</p>}
          {author.website && <a href={author.website} target="_blank" rel="noopener noreferrer" className="inline-block mt-5 font-type text-xs uppercase tracking-widest border-b border-[#121210] hover:text-[#C84B31]" data-testid="author-website-link">Website ↗</a>}
        </div>
        <div className="lg:col-span-4">
          <JoinReaders endpoint={`/public/authors/${slug}/subscribe`} authorName={author.name} testid="author-join" />
        </div>
      </section>
      <section className="py-14">
        <p className="label-mono mb-10">Books · {books.length}</p>
        {books.length === 0 ? <p className="font-display italic text-2xl text-[#5C584E]">No books on the shelf yet.</p> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
            {books.map((b) => (
              <Link key={b.id} to={`/b/${b.slug}`} className="group" data-testid={`author-book-${b.slug}`}>
                <BookCover src={b.cover_url} title={b.title} author={author.name} className="transition-transform duration-300 group-hover:-translate-y-2 group-hover:rotate-1" />
                <h3 className="font-display text-xl mt-5 group-hover:text-[#C84B31]">{b.title}</h3>
                <p className="label-mono mt-1">{b.genre}</p>
              </Link>
            ))}
          </div>
        )}
        <div className="mt-16"><MadeWith /></div>
      </section>
    </div>
  );
}
